import { RefObject, useEffect, useState } from 'react';
import {
  PermissionEnum,
  SchemaFilterType,
  useGetList,
  useQueryState,
  useScroll,
} from '@ui/src';
import { useLazyGetDictionariesQuery } from '../../store/service';
import { Dictionary } from '../../types';
import { schema } from '../variables/list';

const useList = ({
  activePermissions,
  dictionaries,
  scrollRef,
}: {
  activePermissions?: PermissionEnum[];
  dictionaries?: Dictionary[];
  scrollRef: RefObject<HTMLDivElement | null>;
}) => {
  const [takeCount, setTakeCount] = useState(0);

  const [getDictionaries, { isLoading, isFetching }] =
    useLazyGetDictionariesQuery();

  const { filters, onSortChange, onFilterChange } = useQueryState(schema);

  const { getListAction, setPage, errorList } = useGetList<Dictionary>({
    getList: getDictionaries,
    onSortChange,
    onFilterChange,
    schema,
  });

  useScroll({
    element: scrollRef,
    requestInProgress: isFetching,
  });

  useEffect(() => {
    if (
      !dictionaries &&
      !Object.keys(filters).length &&
      takeCount !== 0 &&
      activePermissions?.includes(PermissionEnum.DICTIONARIES_LIST)
    ) {
      getListAction({
        filters: {
          take: {
            value: [takeCount.toString()],
            type: SchemaFilterType.STRING,
          },
        },
      });
    }
  }, [filters, dictionaries, takeCount, activePermissions]);

  useEffect(() => {
    if (scrollRef && scrollRef.current) {
      const { offsetHeight } = scrollRef.current;

      if (offsetHeight) {
        const take = offsetHeight / 58;

        setTakeCount(Math.ceil(take + 3));
      }
    }
  }, [scrollRef]);

  return {
    isLoading,
    setPage,
    errorList,
    filters,
    isFetching,
    takeCount,
  };
};

export default useList;
